import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { InfoOutlined } from '@mui/icons-material';
import { Box, Checkbox, FormControlLabel, TextField, Tooltip, Typography } from '@mui/material';

import WaeButton from '../../../components/Button';
import { SEARCHBAR_BACKGROUND } from '../../../components/FreeTextSearchFilter';
import { SearchableSelectDropdownFilter } from '../../../components/SearchableSelectDropdownFilter/SearchableSelectDropdownFilter';
import { PRIMARY_COLOR } from '../../../theme/colorConstants';

const WorkerTimecardLastDepartmentRow = ({
  corporationId,
  department,
  isValidDepartments,
  onUpdate,
  onDepartmentChange,
  departmentAPICallback,
}) => (
  <Box display="flex" gap="24px" alignItems="end">
    <SearchableSelectDropdownFilter
      disabled={!corporationId}
      placeholder="Department"
      onValueChange={onDepartmentChange}
      optionsAPICallback={departmentAPICallback(corporationId, department?.departmentId)}
      getOptionLabel={(option) => option.name}
      background={SEARCHBAR_BACKGROUND.DEFAULT}
      initialValue={department?.departmentId}
    />
    <TextField
      id="time-worked-input"
      label={LanguageConverterV2('timekeeping.workerTimecard.department.timeWorked')}
      variant="standard"
      disabled
      value={parseFloat(department?.allocatedTime ?? 0).toFixed(2)}
      sx={{ width: '100px' }}
    />
    <FormControlLabel
      value
      control={<Checkbox checked disabled sx={{ padding: 0 }} />}
      label={
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <Typography color="black" fontSize="12px">
            {LanguageConverterV2('timekeeping.workerTimecard.remainingTime')}
          </Typography>
          <Tooltip title="Any remaining time for this scheduled shift will be added to this department">
            <InfoOutlined sx={{ color: PRIMARY_COLOR[50] }} />
          </Tooltip>
        </Box>
      }
      labelPlacement="top"
      sx={{ alignItems: 'start' }}
    />
    <WaeButton onClick={onUpdate} disabled={!isValidDepartments}>
      {LanguageConverterV2('timekeeping.workerTimecard.department.doneButton')}
    </WaeButton>
  </Box>
);

WorkerTimecardLastDepartmentRow.propTypes = {
  corporationId: PropTypes.string,
  isValidDepartments: PropTypes.bool,
  department: PropTypes.shape({
    departmentId: PropTypes.string,
    name: PropTypes.string,
    allocatedTime: PropTypes.number,
  }),
  onUpdate: PropTypes.func,
  onDepartmentChange: PropTypes.func,
  departmentAPICallback: PropTypes.func,
};

export default WorkerTimecardLastDepartmentRow;
